"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTranslation = exports.setLocale = void 0;
var react_1 = require("react");
var zh_cn_1 = require("./locale/zh_cn");
var config_context_1 = require("../_util/config-context");
var translationMap_1 = require("./translationMap");
// 约定中语言名不规范
var lngs = {
    zh: 'zh_cn',
    en: 'en_us',
    jp: 'ja',
};
function setLocale() {
    console.error('`setLocale()` 方法已废弃');
}
exports.setLocale = setLocale;
function useTranslation(moment) {
    var configLocale = (0, config_context_1.useConfig)().locale;
    var t = translationMap_1.translationMap[configLocale] || zh_cn_1.zh_cn;
    var locale = lngs[t.locale] || t.locale;
    (0, react_1.useState)(function () {
        if (moment) {
            moment.locale(locale);
        }
    });
    (0, react_1.useEffect)(function () {
        if (moment) {
            moment.locale(locale);
        }
    }, [locale]); // eslint-disable-line react-hooks/exhaustive-deps
    return t;
}
exports.useTranslation = useTranslation;
